import Page from '../../../shared/components/Page/Page';
import {useContext, useEffect, useState} from "react";
import {Button, Form, Input, message, Modal, Space, Table, Tag} from "antd";
import LoadingContext from "../../../app/contexts/LoadingContext";
import {formatDateTime} from "../../../shared/utils/helpers";
import {EditOutlined, SecurityScanOutlined} from "@ant-design/icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faAdd, faGlobe} from "@fortawesome/free-solid-svg-icons";
import { adminGetIpAddress as getIpAddress } from "../api";
import { adminUpdateInfo as updateInfo } from "../api";
import EditTableCell from "../../../shared/components/Table/EditTableCell/EditTableCell";
import FormDrawer from "../../../shared/components/FormDrawer/FormDrawer";
import { getAdministrators } from "../api";
import { createAdministrator } from "../api";
import { adminChangeIpAddress as changeIpAddress } from "../api";
import { changePassword } from "../../account/api";
function Administration() {
    const [data,setData] = useState([]);
    const [tableLoading,setTableLoading] = useState(false);
    const [formAdd] = Form.useForm();
    const [open,setOpen] = useState(false);
    const [openModelIpAddress, setOpenIpAddress] = useState(false);
    const [openFormPassword,setOpenFormPassword] = useState(false);
    const [tableLoadingIpAddress,setTableLoadingIpAddress] = useState(false);
    const [record,setRecord] = useState({});
    const [formIpAddress] = Form.useForm();
    const [loadingBtnIpAddress,setLoadingBtnIpAddress] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const { setLoading } = useContext(LoadingContext);
    const editingKey = '';
    const [editing, setEditing] = useState('');
    const [formPartner] = Form.useForm();
    const [formPassword] = Form.useForm();
    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const isEditing = (_record) => _record.adminId === editing;
    const cancelPartner = () => {
        setEditing('');
    }
    const permissionOptions = [
        { value: 'manage_pay_in', label: 'Quản lý IN' },
        { value: 'manage_pay_out', label: 'Quản lý OUT' },
        { value: 'manage_blocked_banks', label: 'Quản lý ngân hàng bị chặn' },
        { value: 'manage_users', label: 'Quản lý người dùng' },
        { value: 'manage_settings', label: 'Quản lý cấu hình' },
        { value: 'manage_banks', label: 'Quản lý ngân hàng' },
        { value: 'manage_withdrawals', label: 'Quản lý rút tiền' },
        { value: 'manage_deposits', label: 'Quản lý nạp tiền' },
        { value: 'manage_partners', label: 'Quản lý đối tác' },
        { value: 'manage_administrators', label: 'Quản lý quản trị viên' },
        { value: 'manage_bank_withdrawals', label: 'Quản lý rút tiền ngân hàng' },
        { value: 'manage_bank_transactions', label: 'Quản lý giao dịch ngân hàng' },
        { value: "view_transactions", label: "Xem biến động số dư" }
    ];
    const itemAdds = [
        {
            name: 'name',
            placeholder: 'Nhập tên',
            type: 'text',
            label: 'Tên',
            required: true
        },
        {
            name: 'username',
            placeholder: 'Nhập tên tài khoản',
            type: 'text',
            label: 'Tên tài khoản',
            required: true
        },
        {
            name: 'email',
            placeholder: 'Nhập Email',
            type: 'text',
            label: 'Email',
            required: false
        },
        {
            name: 'password',
            placeholder: 'Nhập mật khẩu',
            type: 'password',
            label: 'Mật khẩu',
            required: true
        },
        {
            name: 'rePassword',
            placeholder: 'Nhập lại mật khẩu',
            type: 'password',
            label: 'Xác nhận mật khẩu',
            required: true
        },
        {
            name: 'permissions',
            placeholder: 'Chọn quyền',
            type: 'checkbox-group',
            label: 'Quyền hạn',
            required: true,
            options: permissionOptions
        },
    ]
    const columns = [
        {
            title: 'ID',
            dataIndex: 'adminId',
            sorter: true,
            align: 'center'
        },
        {
            title: 'Tên',
            dataIndex: 'name',
            align: 'center',
            editable: true,
            inputType: 'text',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Tên tài khoản',
            dataIndex: 'username',
            align: 'center',
            render: (value) => {
                return <Tag>{value}</Tag>
            }
        },
        {
            title: 'Email',
            dataIndex: 'email',
            align: 'center',
            editable: true,
            inputType: 'text',
            render: (value) => {
                return (value) ? <Tag>{value}</Tag> : <Tag>Trống</Tag>
            }
        },
        {
            title: 'Quyền hạn',
            dataIndex: 'permissionsList',
            align: 'center',
            editable: true,
            inputType: 'checkbox-group',
            options: permissionOptions,
            render: (permissions) => {
                if (!permissions || permissions.length === 0) {
                    return <Tag color="red">Chưa có quyền</Tag>;
                }
                return (
                    <Space wrap>
                        {permissions.map(perm => {
                            const permission = permissionOptions.find(p => p.value === perm);
                            return permission ? (
                                <Tag color="green" key={perm}>
                                    {permission.label}
                                </Tag>
                            ) : null;
                        })}
                    </Space>
                );
            }
        },
        {
            title: 'Xác thực 2 lớp',
            dataIndex: 'is2faEnabled',
            align: 'center',
            editable: true,
            inputType: 'switch',
            filters: [
                {
                    text: 'Tắt',
                    value: false
                },
                {
                    text: 'Bật',
                    value: true
                }
            ],
            render: (value) => {
                if (value) {
                    return <Tag color={'green'}>Bật</Tag>
                }
                return <Tag color={'red'}>Tắt</Tag>
            }
        },
        {
            title: 'Trạng thái',
            dataIndex: 'isBanned',
            align: 'center',
            editable: true,
            inputType: 'select',
            filters: [
                {
                    text: 'Hoạt động',
                    value: false
                },
                {
                    text: 'Bị chặn',
                    value: true
                }
            ],
            render: (value) => {
                if (value === false) {
                    return <Tag color={'green'}>Hoạt động</Tag>
                }
                return <Tag color={'red'}>Bị chặn</Tag>
            }
        },
        {
            title: 'Thời gian tạo',
            dataIndex: 'createdAt',
            sorter: true,
            align: 'center',
            render: (value) => {
                return formatDateTime(value);
            }
        },
        {
            title: 'Hành động',
            dataIndex: 'operation',
            align: 'center',
            render: (_,_record) => {
                const editable = isEditing(_record);
                return editable ? (
                    <Space>
                        <Button
                            type={'primary'}
                            onClick={() => save(_record.adminId)}
                            ghost={true}
                        >Lưu</Button>
                        <Button
                            type={'dashed'}
                            onClick={cancelPartner}
                            danger={true}
                        >Hủy</Button>
                    </Space>
                ) : (
                    <Space>
                        <Button icon={<SecurityScanOutlined/>} onClick={() => handleOpenChangePassword(_record)} title={'Chỉnh sửa mật khẩu'}/>
                        <Button icon={<EditOutlined/>} disabled={editingKey !== ''} onClick={() => edit(_record)} title={'Chỉnh sửa'}/>
                        <Button onClick={() => handleIpAddress(_record)} icon={<FontAwesomeIcon icon={faGlobe}/>} title={'Địa chỉ IP'}/>
                    </Space>
                )
            }
        }
    ];
    const handleIpAddress = async (_record) => {
        setOpenIpAddress(true);
        await fetchIpAddress(_record.adminId);
        setRecord(_record);
    }
    const handleOpenChangePassword = async (_record) => {
        setOpenFormPassword(true);
        setRecord(_record);
    }
    const fetchIpAddress = async (adminId) => {
        setTableLoadingIpAddress(true);
        const response = await getIpAddress(adminId);
        if (response.success) {
            formIpAddress.setFieldValue('ipAllowList', response.data.ipAllowList)
        }
        setTableLoadingIpAddress(false);
    }
    const fetchData = async () => {
        setTableLoading(true);
        try {
            const response = await getAdministrators(tableParams);
            if (response.success) {
                setData(response.data.data);
                setTableParams({
                    ...tableParams,
                    pagination: {
                        ...tableParams.pagination,
                        total: response.data.total
                    },
                });
            }
        }
        catch (e) {}
        setTableLoading(false);
    }
    const handleTableChange = (pagination, filters, sorter) => {
        setTableParams({
            pagination,
            filters,
            sorter,
        });
    };
    const handleSubmitAdd = async (values) => {
        const response = await createAdministrator( values);
        if (response.success) {
            const newDataSource = [...data, response.data];
            setData(newDataSource);
        }
        setLoading(false);
    }
    const handleAddIpAddress = () => {
        setLoadingBtnIpAddress(true);
        const fetchAddIpAddress = async () => {
            const response = await changeIpAddress( {
                adminId: record.adminId,
                ipAllowList: formIpAddress.getFieldValue('ipAllowList')
            });
            if (response.success) {
                messageApi.success('Cập nhật danh sách địa chỉ IP cho phép thành công.');
            }
            else {
                messageApi.error(response.message);
            }
        }
        fetchAddIpAddress().finally(() => setLoadingBtnIpAddress(false));
    }
    const handleChangePassword = async () => {
        setLoading(true);
        const data = formPassword.getFieldsValue();
        const response = await changePassword( record.adminId, data.password, data.rePassword);
        if (response.success) {
            messageApi.success('Cập nhật mật khẩu cho đối tác thành công.');
        }
        else {
            messageApi.error(response.message);
        }
        setLoading(false);
    };
    const edit = (_record) => {
        formPartner.setFieldsValue({
            email: '',
            role: _record.role || 'supporter',
            ..._record
        })
        setEditing(_record.adminId);
    }
    const save = async (adminId)=> {
        setTableLoading(true);
        try {
            const row = await formPartner.validateFields();
            const params = {
                adminId,
                ...row
            };
            const response = await updateInfo( params);
            if (response.success) {
                update(adminId, row);
                message.success('Cập nhật thông tin quản trị viên thành công');
            }
            else {
                message.error(response.message);
            }
        } catch (e) {
            console.log('Validate Failed:', e);
        }
        finally {
            setTableLoading(false);
        }
    }
    const update = (adminId, row) => {
        const newData = [...data];
        const index = newData.findIndex((item) => adminId === item.adminId);
        if (index > -1) {
            const item = newData[index];
            newData.splice(index, 1, {
                ...item,
                ...row,
            });
            setData(newData);
            setEditing('');
        } else {
            newData.push(row);
            setData(newData);
            setEditing('');
        }
    }
    const mergedColumnPartners = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (_record) => ({
                _record,
                inputType: col.inputType,
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(_record),
                filters: col.filters ?? [],
                options: col.options
            }),
        };
    });
    useEffect(() => {
        fetchData().finally(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        tableParams.pagination?.current,
        tableParams.pagination?.pageSize,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.sorter),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.search),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(tableParams.filters),
    ]);
    return (
        <Page title="Quản trị">
            {contextHolder}
            <Space
                style={{
                    marginBottom: 16,
                }}
            >
                <Button type={'primary'} ghost={true} onClick={() => setOpen(true)} icon={<FontAwesomeIcon icon={faAdd}/>}>Thêm hỗ trợ</Button>
            </Space>
            <Form
                form={formPartner}
                component={false}
            >
                <Table
                    rowKey={'adminId'}
                    columns={mergedColumnPartners}
                    dataSource={data}
                    bordered={true}
                    scroll={{
                        x: 2000,
                    }}
                    loading={tableLoading}
                    pagination={tableParams.pagination}
                    onChange={handleTableChange}
                    components={{
                        body: {
                            cell: EditTableCell
                        }
                    }}
                    rowClassName={'editable-row'}
                />
            </Form>
            <FormDrawer
                open={open}
                form={formAdd}
                onClose={() => setOpen(false)}
                items={itemAdds}
                onSubmit={handleSubmitAdd}
                title={'Thêm mới quản lý'}
            />
            <FormDrawer
                form={formPassword}
                open={openFormPassword}
                onClose={() => setOpenFormPassword(false)}
                items={[{
                    name: 'password',
                    placeholder: 'Nhập mật khẩu',
                    type: 'password',
                    label: 'Mật khẩu',
                    required: true
                },
                    {
                        name: 'rePassword',
                        placeholder: 'Nhập lại mật khẩu',
                        type: 'password',
                        label: 'Xác nhận mật khẩu',
                        required: true
                    }]}
                onSubmit={handleChangePassword}
                title={'Chỉnh sửa mật khẩu'}
            />
            <Modal
                title={'Quản lý địa chỉ IP cho phép'}
                open={openModelIpAddress}
                onCancel={() => setOpenIpAddress(false)}
                width={800}
                footer={null}
                loading={tableLoadingIpAddress}
            >
                <Form
                    form={formIpAddress}
                    layout="vertical"
                    onFinish={handleAddIpAddress}
                >
                    <Form.Item
                        name={'ipAllowList'}
                        label="Danh sách IP"
                    >
                        <Input.TextArea
                            rows={6}
                            placeholder="Danh sách IP đã được thêm"
                        />
                    </Form.Item>
                    <Form.Item>
                        <Button loading={loadingBtnIpAddress} type="primary" htmlType="submit">
                            Xác nhận
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </Page>
    )
}
export default Administration;